// extracted by mini-css-extract-plugin
module.exports = {"resourceLanguageWrapper":"ResourceLanguageWrapper_resourceLanguageWrapper__3cWYS"};